import en from "./english";
import du from "./dutch";
export const BUTTONS = {
  en,
  du,
};
